import React from 'react';
import { Nav, TabProps } from 'react-bootstrap';
import classNames from 'classnames';

import styles from '../Tab/Tab.module.scss';

const BtnTab: React.FC<TabProps> = ({ title, saveChanges }) => (
  <button
    type="button"
    onClick={saveChanges}
    className={classNames('border border-bottom-0 border-white rounded-top ml-2 nav-item p-0', styles.tab)}
  >
    <Nav.Link className="d-flex justify-content-center align-items-center text-white">
      <span className="text-center">{title}</span>
    </Nav.Link>
  </button>
);

export default BtnTab;
